import apiClient from './ApiService'

export default {
  getAfiliados(page = 1, limit = 15, filters = {}) {
    // Asegurarse de que page sea un número
    const pageNum = typeof page === 'number' ? page : 1
    
    return apiClient.get('/afiliados', {
      params: {
        page: pageNum,
        limit,
        ...filters
      }
    })
  },
  
  getAfiliado(id) {
    return apiClient.get(`/afiliados/${id}`)
  },
  
  createAfiliado(afiliado) {
    return apiClient.post('/afiliados', afiliado)
  },
  
  updateAfiliado(id, afiliado) {
    return apiClient.put(`/afiliados/${id}`, afiliado)
  },
  
  deleteAfiliado(id) {
    return apiClient.delete(`/afiliados/${id}`)
  },
  
  generarCarnet(id) {
    return apiClient.get(`/afiliados/${id}/carnet`, {
      responseType: 'blob'
    })
  },
  
  generarCarnetsMasivos(ids) {
    return apiClient.post('/afiliados/carnets-masivos', { ids }, {
      responseType: 'blob'
    })
  },
  
  exportarListado(formato, filtros = {}) {
    return apiClient.get('/afiliados/exportar', {
      params: {
        formato,
        ...filtros
      },
      responseType: 'blob'
    })
  },
  
  generarFicheroSEPA(fecha) {
    return apiClient.get('/afiliados/sepa', {
      params: { fecha },
      responseType: 'blob'
    })
  },
  
  generarFicheroSEPAMasivo(ids, datos) {
    return apiClient.post('/afiliados/sepa-masivo', {
      ids,
      ...datos
    })
  },
  
  generarQRCarnet(id) {
    return apiClient.get(`/afiliados/${id}/qr-carnet`, {
      responseType: 'blob'
    })
  },
  
  generarQRCarnetsMasivos(ids) {
    return apiClient.post('/afiliados/qr-carnets-masivos', { ids }, {
      responseType: 'blob'
    })
  },
  
  descargarPlantillaCargaMasiva() {
    return apiClient.get('/afiliados/plantilla-carga-masiva', {
      responseType: 'blob'
    })
  },
  
  cargaMasivaAfiliados(formData) {
    return apiClient.post('/afiliados/carga-masiva', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  exportarWalletUrls(ids) {
    return apiClient.post('/afiliados/wallet-urls', { ids }, {
      responseType: 'blob'
    })
  },
  
  enviarCarnetEmail(id, email) {
    return apiClient.post(`/afiliados/${id}/enviar-carnet-email`, { email })
  }
}